module.exports = __webpack_public_path__ + "media/LocationAndOfflineMode.12217600.mp4";